import { createFileRoute } from '@tanstack/react-router';

import Subscription from '~/subscription/Subscription';

export const Route = createFileRoute('/_protected/account/subscriptions')({
  component: Subscription,
});
